import { render, staticRenderFns } from "./CCardQaPanel.vue?vue&type=template&id=b1c4d990&scoped=true"
import script from "./CCardQaPanel.vue?vue&type=script&lang=js"
export * from "./CCardQaPanel.vue?vue&type=script&lang=js"
import style0 from "./CCardQaPanel.vue?vue&type=style&index=0&id=b1c4d990&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c4d990",
  null
  
)

export default component.exports